import {
  Button,
  Flex,
  type FlexProps,
  Icon,
  type IconProps,
  Text,
} from '@chakra-ui/react'
import React, { ReactNode, useMemo } from 'react'

import {
  TextButtonVariants,
  useTextButtonStyle,
} from './componentStyles/TextButton.style'

interface TextButtonProps {
  children: ReactNode
  textButtonProps?: FlexProps
  leftIcon?: React.ComponentType<any>
  leftIconProps?: IconProps
  rightIcon?: React.ComponentType<any>
  rightIconProps?: IconProps
  iconSize?: string
  variant?: TextButtonVariants
  onLinkClick: () => void
  hoverChanged?: (hovered: boolean) => void
  iconStrokeWidth?: string
}
export const TextButton = React.forwardRef<HTMLDivElement, TextButtonProps>(
  (
    {
      children,
      textButtonProps,
      onLinkClick,
      hoverChanged,
      leftIcon,
      leftIconProps,
      rightIcon,
      rightIconProps,
      iconSize,
      variant,
      iconStrokeWidth = '2px',
    }: TextButtonProps,
    ref,
  ) => {
    const styles = useTextButtonStyle({ iconSize, variant })

    const leftIconContent = useMemo(() => {
      if (!leftIcon) {
        return null
      }
      const LeftIconComp = leftIcon

      return (
        <Icon
          {...leftIconProps}
          {...styles.icon}
          {...leftIconProps}
          css={{
            '& path': {
              strokeWidth: iconStrokeWidth,
            },
          }}
        >
          <LeftIconComp size="100%" />
        </Icon>
      )
    }, [leftIcon])

    const rightIconContent = useMemo(() => {
      if (!rightIcon) {
        return null
      }
      const RightIconComp = rightIcon

      return (
        <Icon
          {...rightIconProps}
          {...styles.icon}
          {...rightIconProps}
          css={{
            '& path': {
              strokeWidth: iconStrokeWidth,
            },
          }}
        >
          <RightIconComp size="100%" />
        </Icon>
      )
    }, [rightIcon])

    return (
      <Flex
        data-group
        {...styles.container}
        {...textButtonProps}
        as={Button}
        onClick={onLinkClick}
        ref={ref}
      >
        {leftIconContent}
        <Text
          {...styles.text}
          onMouseEnter={() => hoverChanged?.(true)}
          onMouseLeave={() => hoverChanged?.(false)}
        >
          {children}
        </Text>
        {rightIconContent}
      </Flex>
    )
  },
)
